import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import axios from "axios";
import "./SuperStarContent.css";
import Nav from "../../../../../Layouts/Partial/PromoAdminNav";
import ReactPlayer from "react-player";
import swal from "sweetalert";
import useVdieoHandleS3 from "../../../../../CustomHooks/useVideoHandleS3";
import useThumbnailHandleS3 from "../../../../../CustomHooks/useThumbnailHandleS3";
import MediaUploadProgressBar from "../../../../../Screen/MediaUploadProgressBar";
import { serverInfo } from "../../../../../App";
import useVideoHandleWithCompress from "../../../../../CustomHooks/useVideoHandleWithCompress";

const EditPromoVideo = () => {
  const history = useHistory();

  const { id } = useParams();

  const { imageCdnUrl , videoCdnUrl } = useContext(serverInfo);

  const [loading, setLoading] = useState(false);
  const [pendingLiveChatNumber, setPendingLiveChatNumber] = useState([]);
  const [event, setEvent] = useState({});
  const [starList, setStarList] = useState([]);

  // Video File Handle
  const videoInputRef = useRef(null);
  const [videoPath, setVideoPath] = useState("");
  const [video, setVideo] = useState('');
  const [videoDelKey, setVideoDelKey] = useState(null);
  const [videoUrl, videoKey, videoProgress, videoHeight,videoWidth] = useVideoHandleWithCompress(video, 'promoVideos', videoDelKey);


  // Thumbnail File Handle
  const thumbInputRef = useRef(null);
  const [thumbPath, setThumbPath] = useState("");
  const [thumbnail, setThumbnail] = useState('');
  const [thumbnailDelKey, setThumbnailDelKey] = useState(null);
  const [thumbImageUrl, thumbImageKey, thumbProgress] = useThumbnailHandleS3(thumbnail, 'promoVideos/thumbnail', thumbnailDelKey);

  const [registerInput, setRegister] = useState({
    star_id: "",
    title: "",
    video_url: "",
    star_approval: "",
    status: "",
    error_list: [],
  });

  const getStars = () => {
    axios.get(`/api/admin/star_list`).then((res) => {
      if (res.status === 200) {
        setStarList(res.data.star);
      }
    });
  };

  useEffect(() => {
    getStars();
    getPromoVideo(id);
  }, [id]);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setRegister((prev) => {
      return { ...prev, [name]: value };
    });
  };

  // Video handle
  const handleChangeVideo = (file) => {
    setVideoDelKey(videoKey);
    setVideo('');
    setVideo(file[0]);
  };

  const deleteVideo = () => {
    setVideo('');
    setVideoDelKey(videoKey);
    videoInputRef.current.value = '';
  }

  // Thumbnail handle
  const handleThumbnail = (file) => {
    setThumbnailDelKey(thumbImageKey);
    setThumbnail(file[0]);
  };
  const deleteThumbnail = () => {
    setThumbnail('');
    setThumbnailDelKey(thumbImageKey);
    thumbInputRef.current.value = '';
  }

  const promoUpdate = (e) => {
    e.preventDefault();
    setLoading(true);
    const fData = new FormData();
    fData.append("id", event.id);
    fData.append("star_id", registerInput.star_id);
    fData.append("title", registerInput.title);
    fData.append("video_url", videoKey ? videoKey : videoPath);
    fData.append("thumbnail", thumbImageKey ? thumbImageKey : thumbPath);

    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.post(`/api/admin/promoVideo/update`, fData).then((res) => {
        setLoading(false);
        if (res.data.status === 200) {
          if (video) {
            setVideo('');
            setVideoDelKey(videoPath.split("com/").pop())
          }
          if (thumbnail) {
            setThumbnail('');
            setThumbnailDelKey(thumbPath.split("com/").pop())
          }

          swal("Success", res.data.message, "success");
          history.push("/superstar-admin/pending/promoVideo");
        } else {
          //setModalShow(true);
          setRegister({
            ...registerInput,
            error_list: res.data.validation_errors,
          });
        }
      });
    });
  };

  const getPromoVideo = (id) => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/admin/promoVideo/edit/${id}`).then((res) => {
        if (res.data.status === 200) {
          let promo = res.data.promo_video;
          setRegister({
            ...registerInput,
            title: promo.title,
            star_id: promo.star_id,
          });
          setEvent(promo);
          setVideoPath(promo.video_url?promo?.video_url:'');
          setThumbPath(promo.thumbnail?promo?.thumbnail:'');
        }
      });
    });
  };

  const edit = (id) => {};

  return (
    <>
      <div className="AS">
        <Nav></Nav>

        <div
          className="my-4"
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <div className="Modal-js-body">
            <div className="container-lg">
              <div className="row">
                <div className="clo-sm-12 col-md-12 col-lg-9 mx-auto">
                  <form
                    className="p-3"
                    onSubmit={promoUpdate}
                    id="input_form"
                    encType="multipart/form-data"
                  >
                    <div className="form-group row my-4">
                      <label className="col-sm-3 col-form-label col-form-label-sm input-text-lv-ch">
                        Select Star
                      </label>

                      <div className="col-sm-9">
                        <select
                          onChange={handleInput}
                          name="star_id"
                          className="form-control reply-control"
                          value={registerInput.star_id}
                        >
                          <option className="text-black" value="">
                            --- Select Star ---
                          </option>

                          {starList.map((user, index) => (
                            <option className="text-black" value={user.id}>
                              {user.first_name} {user.last_name}
                            </option>
                          ))}
                        </select>
                        <small className="text-danger">
                          {registerInput.error_list?.star_id}
                        </small>
                      </div>
                    </div>
                    <div className="form-group row my-4">
                      <label className="col-sm-3 col-form-label col-form-label-sm input-text-lv-ch ">
                        Title
                      </label>
                      <div className="col-sm-9">
                        <input
                          type="text"
                          className="form-control reply-control"
                          placeholder="Enter title here...!"
                          onChange={handleInput}
                          name="title"
                          value={registerInput.title}
                        />
                        <span className="text-danger">
                          {registerInput.error_list?.title}
                        </span>
                      </div>
                    </div>
                    <div className="form-group row my-4">
                      <label
                        for="video_url"
                        className="col-sm-3 col-form-label col-form-label-sm input-text-lv-ch "
                      >
                        Upload Video
                      </label>

                      <div className="col-sm-9">
                      {videoUrl && video ? (
                        <div className="position-relative">
                          <ReactPlayer
                            url={videoUrl + videoUrl}
                            controls
                            playing={false}
                            volume={1}
                            width="100%"
                            height="200px" // style={{ margin: "0 auto" }}
                          />
                          <span className="text-warning right-cross-button" onClick={deleteVideo}>X</span>
                        </div>


                        ) : <ReactPlayer
                          url={videoCdnUrl + videoPath}
                          controls
                          playing={false}
                          volume={1}
                          width="100%"
                          height="200px" // style={{ margin: "0 auto" }}
                        />}
                        <input
                          type="file"
                          className="form-control reply-control"
                          placeholder="Enter title here...!"
                          onChange={(e) => handleChangeVideo(e.target.files)}
                          name="video_url"
                          ref={videoInputRef}
                        />
                        {video && !videoUrl && <MediaUploadProgressBar progress={videoProgress} />}
                        <span className="text-danger">
                          {registerInput.error_list?.video_url}
                        </span>
                      </div>
                    </div>
                    <div className="form-group row my-4">
                      <label
                        for="thumbnail"
                        className="col-sm-3 col-form-label col-form-label-sm input-text-lv-ch "
                      >
                        Upload Video Thumbnail
                      </label>
                      <div className="col-sm-9">
                      {thumbImageUrl && thumbnail ? (
                            <div className="position-relative">
                              <img
                                src={thumbImageUrl}
                                className="demo-preview-image img-fluid"
                                alt=""
                                style={{ height: "200px", width: "400px" }}
                              />
                              <span className="text-warning right-cross-button" onClick={deleteThumbnail}>X</span>
                            </div>

                          ) : (
                            <img
                              src={imageCdnUrl + thumbPath}
                              className="demo-preview-image img-fluid"
                              alt=""
                              style={{ height: "200px", width: "400px" }}
                            />
                          )}

                        <input
                          type="file"
                          className="form-control reply-control"
                          placeholder="Enter title here...!"
                          onChange={(e) =>
                            handleThumbnail(e.target.files)
                          }
                          name="thumbnail"
                          ref={thumbInputRef}
                        />
                        {thumbnail && !thumbImageUrl && <MediaUploadProgressBar progress={thumbProgress} />}
                        <span className="text-danger">
                          {registerInput.error_list?.thumbnail}
                        </span>
                      </div>
                    </div>

                    {/* Update Submit */}
                    <div className="row justify-content-center aligns-items-center my-4 mt-5">
                      <div className="col-md-3"></div>
                      <div className="col-md-9 d-flex justify-content-center aligns-items-center">
                        {loading ? (
                          <>
                            <button className="btn btnUpdate">
                              <i className="fas fa-spinner fa-pulse"></i>{" "}
                            </button>
                          </>
                        ) : (
                          <button
                            className="btn btnUpdate fw-bold"
                            type="submit"
                          >
                            Update
                          </button>
                        )}
                      </div>
                    </div>
                    {/* Update Submit End */}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditPromoVideo;
